// constants for the application
export const FIELD_MANAGEMENT_GROUP_PUBLIC_ID = 'pc_ml:211';
export const FIELD_MANAGEMENT_GROUP_ID = 'FMGRPID';